import { request } from '@langlois/request';

export async function createProduct ({ commit }, { competitionId, data }) {
	try {
		const body = new FormData();

		for (let [key, value] of Object.entries(data)) {
			if (value) body.append(key, value);
		}

		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition/${competitionId}/product`);

		const response = await request.post(url, body);

		if (response.ok) {
			const id = await response.json();

			commit(`addProduct`, {
				competitionId,
				product: {
					...data,
					id
				}
			});
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while creating the product.`,
			type: `warning`
		}, { root: true });
	}
}
